import { TtWidCore } from './ttwid/core';
export class TtWid extends TtWidCore {
    constructor(options) {
        options.needFid = false;
        super(options);
    }
}
